export default __webpack_public_path__ + "static/media/mountainbike-01.603966e2.svg";